<div *ngIf="notification" class="{{ getAlertClass(notification) }}">
  <div class="notification__messages">
    <div [innerHTML]="notification.message"></div>
  </div>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="closeNotifications()"
  ></button>
</div>
